import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'caret-up', 'CaretUp', [["path",{"d":"M18 14l-6 -6l-6 6h12","key":"svg-0"}]]);